// 设备管理简体中文文案
const zh = {
  categoryManagement: "设备类目管理",
  addOrEditEquipmentCategory: "新增/编辑设备类目",
  addOrEditEquipmentInfo: "新增/编辑设备信息",
  addRootCategory: "新增主类目",
  addSubCategory: "新增子类目",
  batchSubCategories: "子类目",
  addBatchSubCategory: "添加子类目",
  removeSubCategory: "移除子类目",
  subCategoryItem: "子类目 {{index}}",
  editCategory: "编辑类目",
  disableCategory: "禁用类目",
  enableCategory: "启用类目",
  categoryCode: "类目编码",
  categoryName: "类目名称",
  categoryDesc: "类目描述",
  sortOrder: "排序",
  level: "层级",
  enabled: "启用",
  disabled: "禁用",
  selectCategoryPlaceholder: "请选择设备类目",
  noCategoryData: "暂无设备类目",
  categoryCodeRequired: "请输入类目编码",
  categoryNameRequired: "请输入类目名称",
  confirmDisableCategory: "禁用后将级联禁用所有子类目，确定继续吗？",
  confirmEnableCategory: "启用后将级联启用所有父类目，确定继续吗？",
  categoryFetchFailed: "设备类目操作失败",
  categoryOperationSucceeded: "设备类目操作成功",
  equipmentLedger: "设备列表",
  myBorrowed: "我的领用",
  maintainUpcoming: "保养到期",
  maintainUpcomingQuery: "保养到期查询",
  equipmentList: "设备列表",
  addEquipment: "新增设备",
  editEquipment: "编辑设备",
  equipmentDetail: "设备详情",
  equipmentCategory: "设备类目",
  equipmentNumber: "设备编号",
  equipmentName: "设备名称",
  equipmentKeywordPlaceholder: "请输入设备关键字",
  equipmentStatus: "设备状态",
  brand: "品牌",
  model: "型号",
  serialNo: "序列号",
  qrCode: "二维码",
  disableEquipment: "禁用",
  enableEquipment: "启用",
  maintenanceRecord: "添加维护",
  borrowEquipment: "领用",
  returnEquipment: "归还",
  recordFlow: "流水记录",
  recordDetail: "记录详情",
  operator: "操作人",
  borrower: "领用人",
  returnAt: "实际归还时间",
  confirmDisableEquipment: "确定禁用该设备吗？",
  confirmEnableEquipment: "确定启用该设备吗？",
  equipmentStateUpdated: "设备状态更新成功",
  equipmentStateUpdateFailed: "设备状态更新失败",
  qrCodeFetchFailed: "二维码获取失败",
  noQrCodeData: "暂无二维码数据",
  addMaintenanceRecord: "添加维护记录",
  recordType: "记录类型",
  recordTypeRequired: "请选择记录类型",
  occurredAt: "发生时间",
  occurredAtRequired: "请选择发生时间",
  expectedReturnAt: "预计归还时间",
  scrapEquipment: "报废",
  confirmScrapEquipment: "设备报废后不可恢复，确定继续吗？",
  recordCost: "费用",
  recordCostCurrency: "币种",
  odometer: "使用量",
  vendor: "服务商",
  recordComment: "备注",
  recordTypesFetchFailed: "记录类型获取失败",
  recordListFetchFailed: "记录流水获取失败",
  recordFetchFailed: "记录详情获取失败",
  noRecordDetail: "暂无记录详情",
  addRecordSucceeded: "维护记录添加成功",
  addRecordFailed: "维护记录添加失败",
  keeperOrg: "保管部门",
  ownedOrg: "购置/所属部门",
  currentUser: "当前使用人",
  location: "位置",
  placeLocation: "放置地点",
  editPlaceLocation: "修改放置地点",
  placeLocationUpdateSucceeded: "放置地点更新成功",
  placeLocationUpdateFailed: "放置地点更新失败",
  maintainDays: "保养周期（天）",
  maintainThreshold: "保养周期（使用量）",
  dueByDays: "天数维度",
  dueByThreshold: "使用量维度",
  due: "已到期",
  notDue: "未到期",
  remainDays: "剩余天数",
  remainThreshold: "剩余使用量",
  lastMaintainAt: "上次保养时间",
  lastMaintainOdometer: "上次使用量",
  currentOdometer: "当前使用量",
  purchaseInfo: "购置信息",
  purchaseAt: "购置时间",
  purchasePrice: "购置价格",
  purchaseCurrency: "购置币种",
  supplier: "供应商",
  createdBy: "创建人",
  createdAt: "创建时间",
  updatedBy: "更新人",
  updatedAt: "更新时间",
  actions: "操作",
  equipmentNameRequired: "请输入设备名称",
  keeperOrgRequired: "请选择保管部门",
  rootCategoryCannotAdd: "根类目不能新增设备，请选择子类目",
  addEquipmentSucceeded: "设备新增成功",
  editEquipmentSucceeded: "设备编辑成功",
  equipmentSaveFailed: "设备保存失败",
  equipmentFetchFailed: "设备详情获取失败",
  equipmentListFetchFailed: "设备列表获取失败",
  myBorrowedFetchFailed: "我的领用设备获取失败",
  upcomingMaintainFetchFailed: "保养到期设备获取失败",
  equipmentStatusFetchFailed: "设备状态获取失败",
  noEquipmentDetail: "暂无设备详情",
};

export default zh;
